import { observer } from "mobx-react-lite"
import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "..";
import AuthAPI from "../API/AuthAPI";
import LicenseAPI from "../API/LicenseAPI"
import MenuElement from "./ui/MenuElement";
import MenuSubElement from "./ui/MenuSubElement";

import "../styles/sideMenu.css"
import { ReactComponent as Logo } from "../images/logo1.svg";
import { ReactComponent as Calc } from "../images/icons/calc.svg";
import { ReactComponent as Porfolio } from "../images/icons/portfolio.svg";
import { ReactComponent as Money } from "../images/icons/money.svg";
import { ReactComponent as FQA } from "../images/icons/faq.svg";
import { ReactComponent as Filter } from "../images/icons/filter.svg";
import { ReactComponent as Find } from "../images/icons/find.svg";
import { ReactComponent as DownArrow } from "../images/icons/downArrow.svg";
import { ReactComponent as Settings } from "../images/icons/settings.svg";
import { ReactComponent as Exit } from "../images/icons/exit.svg";

import { ReactComponent as NotificationError } from "../images/icons/error.svg";
import { ReactComponent as NotificationWarning } from "../images/icons/warning.svg";
import { ReactComponent as NotificationSuccess } from "../images/icons/success.svg";
import { ReactComponent as NotificationInfo } from "../images/icons/info.svg";
import gsap from "gsap";
import SwitcherStage from "./ui/SwitcherStage";
import SwitcherParams from "./ui/SwitcherParams";
import Clicker from "./ui/Clicker";

const SideMenu = ({ children }) => {
    const { store } = useContext(Context);
    const [user, setUser] = useState({});
    const [showProfile, setShowProfile] = useState(false);
    const [showSumm, setShowSumm] = useState(false);

    const [showOverPrice, setShowOverprice] = useState(false);
    const [overPrice, setOverPrice] = useState(0);

    // notification types | 0 - error | 1 - warning | 2 - success | 3 - info
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        getUserData().then(() => console.log("[✓] Данные пользователя загружены"));
        if (window.location.pathname == "/calc") setShowSumm(true);
    }, []);

    // useEffect(() => {
    //     changeOverPrice(store.userInfo.discount, store.userInfo.discountStatus)
    // }, [store.userInfo.discountStatus, store.userInfo.discount]);

    const changeOverPrice = async (discountValue, discountStatus) => {
        try {
            if (discountValue == undefined || discountStatus == undefined) return;
            if (discountValue == store.userInfo.discount && discountStatus == store.userInfo.discountStatus) return;
            store.setDiscount(discountValue);
            store.setDiscountStatus(discountStatus);
            let nowValue = discountValue * (discountStatus == true ? -1 : 1);
            const response = await AuthAPI.editFinalDiscount(nowValue);
            if (response.status == 200) console.log("[+] Скидка/наценка изменена на", nowValue);
            else throw response;
        } catch (err) {
            console.log("[x] Ошибка изменения параметра скидки/наценки:", err);
        }
    }

    const getUserData = async () => {
        try {
            const user = await AuthAPI.account();
            user.data.license.start = new Date(user.data.license.start);
            setUser(user.data);
            store.setUserInfo(user.data);
        } catch(err) {
            console.log(`[user] [err]: ${err}`);
        }
    }
    const buyLicense = async () => {
        const link = await LicenseAPI.getLink();
        console.log(link);
        window.location.href = link.data;
    }
    const logout = () => {
        try {
            store.logout();
        } catch (err) {
            console.log("[logout] error:", err);
        }
    }

    const formatDate = (date) => {
        var dd = date.getDate();
        if (dd < 10) dd = '0' + dd;
        
        var mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;
        
        var yy = date.getFullYear();
        if (yy < 10) yy = '0' + yy;
        
        return dd + '.' + mm + '.' + yy;
    }

    const addNotification = () => {
        let newNotifications = [...notifications];
        newNotifications.push({
            type: 3,
            title: "Информация",
            icon: <NotificationInfo/>,
            text: "Данный параметр невозможно редактировать, поскольку он является системным.",
            hasFaq: false,
            faqLink: "/calc",
        });
        setNotifications(newNotifications);
    }

    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className="pageFrame">
            <div className="sideMenu">
                <div className="sideMenu_block">
                    {/* <button onClick={logout}>Выйти</button>{ store.user.isActivated === true ? "Аккаунт активирован" : "Требуется подтверждение" } <br /> */}
                    {/* { user.isLicensed === false ? <button onClick={() => buyLicense()}>Купить лицензию</button> : "Лицензия активна" } */}
                    <div className="logo_block"><Logo/></div>
                    <div className="menu_block">
                        <ul>
                            <MenuElement name="Калькулятор" Icon={Calc} link="/calc">
                                <MenuSubElement name="Задачи ГБ" link="/calc/mainkeeper"/>
                                <MenuSubElement name="Первичка" link="/calc/primary"/>
                                <MenuSubElement name="Банк" link="/calc/bank"/>
                                <MenuSubElement name="Зарплата" link="/calc/payday"/>
                                <MenuSubElement name="Тарифные опции" link="/calc/rateoptions"/>
                                <MenuSubElement name="ВЭД" link="/calc/fta"/>
                            </MenuElement>
                            <MenuElement name="Должности" Icon={Porfolio} link="/positions"/>
                            <MenuElement name="Расходы" Icon={Money} link="/expenses"/>
                        </ul>
                        {/* <MenuElement name="FQA" Icon={FQA} link="/faq" bordered={true}/> */}
                    </div>
                </div>
                {showSumm && store.userInfo && <div className="calcSumm_block">
                    <div className="title">Итоговая стоимость:</div>
                    <div className="summ">
                        <div className="value">{formatNumber(Math.ceil(store.calcSumm + (store.calcSumm / 100 * store.userInfo.discount * (store.userInfo.discountStatus ? -1 : 1))))} ₽</div>
                        <button className={showOverPrice ? "defaultButton active" : "defaultButton"} onClick={() => setShowOverprice(!showOverPrice)}><Filter/></button>
                    </div>
                    <div className={showOverPrice ? "overPrice show" : "overPrice"}>
                        <SwitcherParams
                            name1="Наценка"
                            name2="Скидка"
                            forceValue={store.userInfo.discount != 0 ? store.userInfo.discountStatus : false}
                            onChangeValue={(newValue) => changeOverPrice(store.userInfo.discount, newValue)}
                            disabled={!store.userInfo || store.userInfo.isLicensed == false}
                        />
                        <Clicker
                            isDecimal={true}
                            max={100}
                            // value={overPrice}
                            // setValue={(newValue) => changeOverPrice(newValue)}
                            value={store.userInfo.discount}
                            setValue={(newValue) => changeOverPrice(newValue, store.userInfo.discountStatus)}
                            step={1}
                            disabled={!store.userInfo || store.userInfo.isLicensed == false}
                        />
                    </div>
                </div>}
            </div>
            <div className="contextBlock">
                <div className="navigationBar">
                    <div className="title_block">
                        <div className="appName">Калькулятор</div>
                        <ul className="breadcrumbs">
                            {/* <li>Задачи ГБ</li>
                            <li className="active">Обязанности ГБ</li> */}
                        </ul>
                    </div>
                    <div className="search_block">
                        <input type="text" placeholder="Поиск (в разработке)" disabled/>
                        <button className="defaultButton disabled"><Filter/></button>
                        <button className="activeButton disabled">
                            <div className="text">Найти</div>
                            <Find/>
                        </button>
                    </div>
                    <div className={showProfile ? "profile_block opened" : "profile_block"} onClick={() => setShowProfile(!showProfile)}>
                        <div className="profile_info">
                            <div className="nickname">
                                <div className="name">{user.name}{user.surname ? ` ${user.surname}` : ""}</div>
                                <button className="activeButton"><DownArrow/></button>
                            </div>
                            {store.userInfo.license && <ul className="rateInfo">
                                <li>
                                    <div className="text">Тариф:</div>
                                    <div className="value">{store.userInfo.license.name}</div>
                                </li>
                                <li>
                                    <div className="text">Дата окончания:</div>
                                    <div className="value">{formatDate(new Date(store.userInfo.license.end))} г.</div>
                                </li>
                            </ul>}
                        </div>
                        <button className="activeButton" onClick={() => window.location.href='/rates'}>Тарифы</button>
                        <ul className="profile_menu">
                            <li onClick={() => window.location.href = "/profile"}><Settings/><label>Настройки</label></li>
                            <li onClick={() => logout()}><Exit/><label>Выйти</label></li>
                        </ul>
                    </div>
                </div>
                <div className="contentBlock" style={{ overflow: "hidden" }}>
                    { store.userInfo && (children) }
                </div>
            </div>
            {/* <ul className="notificationBlock">
                {notifications && notifications.length > 0 && notifications.map((notification, index) => 
                    <li 
                        className={"notif-" + notification.type} 
                        key={notification+index}>
                        <div className="title">
                            <div className="icon">{notification.icon}</div>
                            <div className="text">{notification.title}</div>
                        </div>
                        <div className="content">{notification.text}</div>
                        <div className="buttons">
                            <button className="activeButton">Понятно</button>
                            {notification.hasFaq && <button className="activeButton">FQA</button>}
                        </div>
                    </li>
                )}
            </ul> */}
        </div>
    )
}

export default observer(SideMenu);
